module.exports = __webpack_public_path__ + "static/img/5.22153b15.jpeg";